import { render, staticRenderFns } from "./table-body.vue?vue&type=template&id=47e07f5c&"
import script from "./table-body.vue?vue&type=script&lang=js&"
export * from "./table-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47e07f5c')) {
      api.createRecord('47e07f5c', component.options)
    } else {
      api.reload('47e07f5c', component.options)
    }
    module.hot.accept("./table-body.vue?vue&type=template&id=47e07f5c&", function () {
      api.rerender('47e07f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/table-body.vue"
export default component.exports